<script setup lang="ts">
import { SFButton, SFHeadline } from '#storefront-ui/components'

const { title, actionText = 'view' } = defineProps<{
  title: string
  actionText?: string
}>()

const emit = defineEmits<{
  clickAction: []
}>()

const show = defineModel<boolean>('show', {
  required: true,
  default: false,
})

const closeModel = () => (show.value = false)
</script>

<template>
  <teleport to="body">
    <div v-if="show" class="fixed inset-0 z-[500] flex items-end">
      <!-- Backdrop (fade) -->
      <Transition name="fade-fast">
        <div
          v-if="show"
          class="absolute inset-0 bg-black/50"
          @click="closeModel"
        ></div>
      </Transition>

      <!-- Bottom sheet (slide up) -->
      <Transition name="slide-up-slow">
        <div
          v-if="show"
          class="relative w-full rounded-t-2xl bg-white px-4 py-6 shadow-lg"
        >
          <div class="relative flex w-full flex-col items-center">
            <SFHeadline tag="h5">{{ title }}</SFHeadline>
            <p class="mt-6 text-center text-lg">
              {{
                $t('add_to_basket.notification.add_to_basket_success_subtitle')
              }}
            </p>
            <button class="absolute right-0 top-0" @click="closeModel">
              <IconClose class="size-6" />
            </button>
          </div>

          <div class="mt-4 flex flex-col">
            <div class="w-full py-3">
              <slot />
            </div>
            <div class="mt-4 w-full">
              <SFButton is-full-width @click="emit('clickAction')">{{
                actionText
              }}</SFButton>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </teleport>
</template>

<style scoped>
/* Backdrop fade faster */
.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 150ms ease;
}
.fade-fast-enter-from,
.fade-fast-leave-to {
  opacity: 0;
}

/* Bottom sheet slide up slower */
.slide-up-slow-enter-active,
.slide-up-slow-leave-active {
  transition: transform 300ms ease;
}
.slide-up-slow-enter-from,
.slide-up-slow-leave-to {
  transform: translateY(100%);
}
</style>
